<script>
// import NavBar from '@components/core/nav-bar.vue'
// import Footer from '@components/core/core-footer.vue'
export default {
  props: {
    margin: {
      default: null,
      type: String,
    },
  },
  // components: {
  //   NavBar,
  //   Footer,
  // },
  computed: {
    contentMargin: function() {
      return {
        '--contentMargin': this.margin,
      }
    },
  },
}
</script>

<template>
  <div ref="appWrapper" :class="$style.wrapper">
    <div :id="$style.content" :style="[margin !== null ? contentMargin : '']">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.wrapper {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  min-height: 75vh;
  margin: 0 auto;
}
#content {
  margin: var(--contentMargin);
}
</style>

<style lang="scss">
.card {
  [class='card-body'] {
    padding: 0.75rem;
  }
}
img[lazy='loading'] {
  filter: blur(5px);
}
// img[lazy='error'] {

// }
img[lazy='loaded'] {
  filter: blur(0);
  transition: all 0.3s ease-in-out;
}
@keyframes basicLoading {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.basicLoading {
  position: relative;
  width: 100%;
  height: 100%;
  transform: translateZ(0) scale(1);
  transform-origin: 0 0; /* see note above */
  backface-visibility: hidden;
  div {
    position: absolute;
    top: 100px;
    left: 100px;
    box-sizing: content-box;
    width: 130px;
    height: 130px;
    border: 10px solid #2980b9;
    border-top-color: transparent;
    border-radius: 50%;
    animation: basicLoading 0.7692307692307692s linear infinite;
  }
}
.loadingSpinner {
  display: inline-block;
  width: 200px;
  height: 200px;
  overflow: hidden;
  background: none;
}

/* generated by https://loading.io/ */
</style>
